module.exports = __webpack_public_path__ + "images/branding/manpower/login_button.gif";